var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21598_21591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9722 5.50146C24.9278 5.50146 28.7946 6.67444 32.0836 8.87207C35.3726 11.0697 37.936 14.1933 39.4498 17.8478C40.9635 21.5023 41.3596 25.5237 40.5879 29.4033C39.8162 33.2829 37.9114 36.8465 35.1143 39.6436L28.0432 32.5725C29.4418 31.174 30.3942 29.3922 30.78 27.4524C31.1659 25.5126 30.9678 23.5019 30.211 21.6746C29.4541 19.8474 28.1724 18.2856 26.5279 17.1868C24.8834 16.088 22.95 15.5015 20.9722 15.5015V5.50146Z",
    fill: "#FF0400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21598_21591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1143 39.6436C32.9451 41.8128 30.3059 43.454 27.401 44.4401C24.496 45.4262 21.4032 45.7308 18.3616 45.3304C15.3201 44.9299 12.4115 43.8352 9.86076 42.1309C7.31002 40.4265 5.18554 38.1582 3.65166 35.5015L12.3119 30.5015C13.0789 31.8298 14.1411 32.964 15.4165 33.8162C16.6918 34.6683 18.1462 35.2157 19.6669 35.4159C21.1877 35.6161 22.7341 35.4638 24.1866 34.9708C25.639 34.4777 26.9586 33.6571 28.0432 32.5725L35.1143 39.6436Z",
    fill: "#FFA300"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_21598_21591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65166 35.5015C1.45032 31.6886 0.568605 27.256 1.14327 22.8909C1.71794 18.5259 3.71686 14.4725 6.83003 11.3593L13.9011 18.4304C12.3445 19.987 11.3451 22.0137 11.0577 24.1962C10.7704 26.3787 11.2112 28.595 12.3119 30.5015L3.65166 35.5015Z",
    fill: "#FF6300"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_21598_21591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20928 8.51497C9.80422 5.09235 14.5434 3.12881 19.5056 3.00611L19.7528 13.0031C17.2717 13.0644 14.9021 14.0462 13.1046 15.7575L6.20928 8.51497Z",
    fill: "#FF4200"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_21598_21591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9722 24C19.9722 21.7909 21.763 20 23.9722 20H56.9722C59.1813 20 60.9722 21.7909 60.9722 24V26C60.9722 26.5523 60.5245 27 59.9722 27H20.9722C20.4199 27 19.9722 26.5523 19.9722 26V24Z",
    fill: "url(#paint0_linear_21598_21591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9722 24C19.9722 21.7909 21.763 20 23.9722 20H56.9722C59.1813 20 60.9722 21.7909 60.9722 24V26C60.9722 26.5523 60.5245 27 59.9722 27H20.9722C20.4199 27 19.9722 26.5523 19.9722 26V24Z",
    fill: "url(#paint1_radial_21598_21591)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 24C20.4722 22.067 22.0392 20.5 23.9722 20.5H56.9722C58.9052 20.5 60.4722 22.067 60.4722 24V26C60.4722 26.2761 60.2483 26.5 59.9722 26.5H20.9722C20.696 26.5 20.4722 26.2761 20.4722 26V24Z",
    stroke: "url(#paint2_radial_21598_21591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 24C20.4722 22.067 22.0392 20.5 23.9722 20.5H56.9722C58.9052 20.5 60.4722 22.067 60.4722 24V26C60.4722 26.2761 60.2483 26.5 59.9722 26.5H20.9722C20.696 26.5 20.4722 26.2761 20.4722 26V24Z",
    stroke: "url(#paint3_radial_21598_21591)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 24C20.4722 22.067 22.0392 20.5 23.9722 20.5H56.9722C58.9052 20.5 60.4722 22.067 60.4722 24V26C60.4722 26.2761 60.2483 26.5 59.9722 26.5H20.9722C20.696 26.5 20.4722 26.2761 20.4722 26V24Z",
    stroke: "url(#paint4_radial_21598_21591)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_21598_21591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9722 29C19.9722 28.4477 20.4199 28 20.9722 28H59.9722C60.5245 28 60.9722 28.4477 60.9722 29V54C60.9722 56.2091 59.1813 58 56.9722 58H23.9722C21.763 58 19.9722 56.2091 19.9722 54V29Z",
    fill: "url(#paint5_linear_21598_21591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9722 29C19.9722 28.4477 20.4199 28 20.9722 28H59.9722C60.5245 28 60.9722 28.4477 60.9722 29V54C60.9722 56.2091 59.1813 58 56.9722 58H23.9722C21.763 58 19.9722 56.2091 19.9722 54V29Z",
    fill: "url(#paint6_radial_21598_21591)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 29C20.4722 28.7239 20.696 28.5 20.9722 28.5H59.9722C60.2483 28.5 60.4722 28.7239 60.4722 29V54C60.4722 55.933 58.9052 57.5 56.9722 57.5H23.9722C22.0392 57.5 20.4722 55.933 20.4722 54V29Z",
    stroke: "url(#paint7_radial_21598_21591)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 29C20.4722 28.7239 20.696 28.5 20.9722 28.5H59.9722C60.2483 28.5 60.4722 28.7239 60.4722 29V54C60.4722 55.933 58.9052 57.5 56.9722 57.5H23.9722C22.0392 57.5 20.4722 55.933 20.4722 54V29Z",
    stroke: "url(#paint8_radial_21598_21591)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4722 29C20.4722 28.7239 20.696 28.5 20.9722 28.5H59.9722C60.2483 28.5 60.4722 28.7239 60.4722 29V54C60.4722 55.933 58.9052 57.5 56.9722 57.5H23.9722C22.0392 57.5 20.4722 55.933 20.4722 54V29Z",
    stroke: "url(#paint9_radial_21598_21591)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9722 35C53.0767 35 53.9722 35.8954 53.9722 37C53.9722 38.1046 53.0767 39 51.9722 39L27.9722 39C27.4199 39 26.9722 38.5523 26.9722 38L26.9722 36C26.9722 35.4477 27.4199 35 27.9722 35L51.9722 35Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9722 47C53.0767 47 53.9722 47.8954 53.9722 49C53.9722 50.1046 53.0767 51 51.9722 51L27.9722 51C27.4199 51 26.9722 50.5523 26.9722 50L26.9722 48C26.9722 47.4477 27.4199 47 27.9722 47L51.9722 47Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9722 41C53.0767 41 53.9722 41.8954 53.9722 43C53.9722 44.1046 53.0767 45 51.9722 45L27.9722 45C27.4199 45 26.9722 44.5523 26.9722 44L26.9722 42C26.9722 41.4477 27.4199 41 27.9722 41L51.9722 41Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9722 34C54.0767 34 54.9722 34.8954 54.9722 36C54.9722 37.1046 54.0767 38 52.9722 38L28.9722 38C28.4199 38 27.9722 37.5523 27.9722 37L27.9722 35C27.9722 34.4477 28.4199 34 28.9722 34L52.9722 34Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9722 46C54.0767 46 54.9722 46.8954 54.9722 48C54.9722 49.1046 54.0767 50 52.9722 50L28.9722 50C28.4199 50 27.9722 49.5523 27.9722 49L27.9722 47C27.9722 46.4477 28.4199 46 28.9722 46L52.9722 46Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9722 40C54.0767 40 54.9722 40.8954 54.9722 42C54.9722 43.1046 54.0767 44 52.9722 44L28.9722 44C28.4199 44 27.9722 43.5523 27.9722 43L27.9722 41C27.9722 40.4477 28.4199 40 28.9722 40L52.9722 40Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21598_21591",
    x: 16.9722,
    y: 1.50146,
    width: 28,
    height: 42.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21598_21591",
    x: -0.348145,
    y: 26.5015,
    width: 39.4624,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_21598_21591",
    x: -3.02783,
    y: 7.35933,
    width: 20.9287,
    height: 32.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_21598_21591",
    x: 2.20947,
    y: -0.993889,
    width: 21.5435,
    height: 20.7514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_21598_21591",
    x: 11.9722,
    y: 12,
    width: 57,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_21598_21591",
    x: 11.9722,
    y: 20,
    width: 57,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21598_21591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21598_21591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21598_21591",
    x1: 19.9722,
    y1: 20,
    x2: 20.7137,
    y2: 28.6867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9722 20) scale(41 7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2361 24.5694) rotate(1.04798) scale(15.9471 2.75301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3749 21.2639) rotate(170.311) scale(5.19916 7.62547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4305 21.3611) rotate(161.147) scale(9.02591 6.90047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21598_21591",
    x1: 19.9722,
    y1: 28,
    x2: 32.0721,
    y2: 61.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9722 28) scale(41 30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2361 47.5833) rotate(4.48266) scale(15.9934 11.7645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3749 33.4167) rotate(143.807) scale(6.35044 26.7559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_21598_21591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4305 33.8333) rotate(124.346) scale(15.1397 17.631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.6ab12a8e83bfce236f75cc373a642380.svg";
export { ForwardRef as ReactComponent };